import {
  AlertCircle,
  AlertTriangle,
  Info,
  type LucideIcon,
} from "@/components/icons";

import { TONE_TINT } from "@/components/ui/tone";

export type DialogVariant = "default" | "destructive" | "warning";

export interface DialogVariantConfig {
  icon: LucideIcon;
  chip: string;
  buttonVariant: "primary" | "destructive";
}

export const DIALOG_VARIANT: Record<DialogVariant, DialogVariantConfig> = {
  default: {
    icon: Info,
    chip: "bg-action-tint text-action-strong",
    buttonVariant: "primary",
  },
  destructive: {
    icon: AlertCircle,
    chip: TONE_TINT.destructive,
    buttonVariant: "destructive",
  },
  warning: {
    icon: AlertTriangle,
    chip: TONE_TINT.warning,
    buttonVariant: "primary",
  },
};
